export interface PM_Itme_Interface {
  id:number,
  title:String,
  icon: string,
  parent: number,

  persianDate: string,
  creater:string,
  del: boolean,
  selected: boolean,

  detail:Array<PM_Itme_Interface>
}

export function Empty_PM_Itme_Interface():PM_Itme_Interface{
  return{
    id:0,
    title:'',
    icon:'',
    parent: 0,

    persianDate: '',
    creater:'',
    del: false,
    selected: false,

    detail:[]
  }
}
